// extracted by mini-css-extract-plugin
module.exports = {"card":"CardFaq_card__ugM5i","btnContainer":"CardFaq_btnContainer__VkSTd"};